module.exports = __webpack_public_path__ + "img/62.8e7f8179.jpg";